<template>
  <eagle-form
    :form-key="formKey"
  ></eagle-form>
</template>

<script lang="babel" type="text/babel">
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './contactFormConfig'
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'contact-form',
    meta: {},
  }),
  methods: {
    async beforeFormInit() {
      await Promise.all([])
    },
    validateBeforeSave() {
      // TODO
    },
    async readApi(target) {
      return await this.$api.collection.contactApi.read(target)
    },
    async createApi(formData) {
      return await this.$api.collection.contactApi.create(formData)
    },
    async updateApi(target, formData) {
      return await this.$api.collection.contactApi.update(target, formData)
    },
    async deleteApi(target) {
      return await this.$api.collection.contactApi.delete(target)
    },
    getFormConfig() {
      return formConfig
    },
  },
  computed: {
    feature() {
      return this.$store.getters['base/feature']
    },
    orderModule() {
      return this.feature.orderModule === true
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
